import script from "./AlertOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./AlertOverlay.vue?vue&type=style&index=0&id=6204b5bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6204b5bc"]])

export default __exports__